import React, { useEffect } from "react";
import Highcharts from "highcharts";
require("highcharts/modules/accessibility")(Highcharts);

export default function AnalysisGraph({ summaryReports,id,title,ariaLabel}) {
  let GraphData;
  if(id==="financialGraph"){
     GraphData = [
      {
        name: "Total Sub Contractor Cost",
        y: summaryReports?.FinancialAnalysis?.totalSubContractorCost,
        color: {
          pattern: {
            path: 'M 5 0 L 5 10', // Vertical line
            width: 10,
            height: 10,
            color: '#FFFFFF', // Line color (white)
            backgroundColor: '#003057' 
          }
        },
      },
      {
        name: "Total Expedite Cost",
        y: summaryReports?.FinancialAnalysis?.totalExpediteCost,
        color: {
          pattern: {
            path: 'M 0 0 L 10 10', // Simple diagonal line
            width: 10,
            height: 10,
            color: '#FFFFFF', // Line color (white)
            backgroundColor: '#D2DB0E',
          }
        },
      }
    ];
  }
else{
  GraphData = [
    {
      name: "Delayed",
      y: summaryReports?.DecisionAnalysis?.taskStatus?.Delayed,
      color: {
        pattern: {
          path: 'M 0 0 L 10 10 M 0 10 L 10 0', // Diagonal cross pattern
          width: 10,
          height: 10,
          color: '#BB4A28',
        }
      },
    },
    {
      name: "On Schedule",
      y: summaryReports?.DecisionAnalysis?.taskStatus?.On_Schedule,
      color: {
        pattern: {
          path: 'M 0 0 L 5 10 L 10 0 Z',
          width: 10,
          height: 10,
          color: '#D2DB0E',
        }
      },
    },
    {
      name: "Ahead of Schedule",
      y: summaryReports?.DecisionAnalysis?.taskStatus?.Ahead_of_Schedule,
      color: {
        pattern: {
            path: 'M 0 5 L 10 5', // Horizontal line
            width: 10,
            height: 10,
            color: '#FFFFFF', // Line color (white)
            backgroundColor: '#505759' // Background color (red)
        }
      },
    },
  ];
}

function applyAccessibility(chart) {
    if (chart && chart.renderTo) {
        const svg = chart.renderTo.querySelector("svg.highcharts-root");
        if (svg) {
        setTimeout(() => {
        const chartId = chart.renderTo.id;
        const seriesData = chart.series[0]?.data || [];
        let ariaLabel = '';
        let descText = '';

        if (chartId === "financialGraph") {
            ariaLabel = "Donut chart showing the breakdown of total project cost into subcontract and expedite costs.";
            descText = "This donut chart visualizes the total project cost which is divided into two components: The subcontractor cost, represented by a dark blue striped section. The expedite cost, shown in a yellow-striped section.";
        } else if (chartId === "decisionGraph") {
            ariaLabel = "Donut chart showing the status distribution of tasks as delayed, ahead of schedule, or on schedule.";
            descText = "This donut chart displays the distribution of task statuses at the end of the project. The red crosshatched section indicates delayed tasks. The dark striped section represents tasks completed ahead of schedule. The yellow triangle-filled section shows tasks that were completed on schedule.";
        }

        svg.setAttribute("role", "img");
        svg.setAttribute("aria-label", ariaLabel);

        const oldDesc = svg.querySelector("desc");
        if (oldDesc) oldDesc.remove();

        const desc = document.createElementNS("http://www.w3.org/2000/svg", "desc");
        desc.textContent = descText;
        svg.insertBefore(desc, svg.firstChild);
        },0);
        }
    }
}

  var chart = {
    plotBackgroundColor: null,
    plotBorderWidth: null,
    plotShadow: false,
    marginTop: 50,
    events: {
          render: function () {
              applyAccessibility(this);
          },
          redraw: function () {
              applyAccessibility(this);
          }
    }
  };
  var title = {
    text: `${title}`,
    align: "left",
    style: {
      fontSize: "14px",
    },
  };
  var credits = {
    enabled: false, // Disable the Highcharts bottom link
  };
  var tooltip = {
    pointFormat: "<strong>{point.percentage:.2f}%</strong>",
    borderWidth: 2,
    style: {
      borderColor: function () {
        return this.point.color; // Set the tooltip box border color to match the point color
      },
      opacity:0.9,
      fontSize:'14px',
    }
  };
  var legend = {
    enabled: false,
    align: "left",
    itemStyle: {
      fontWeight: "bold",
      fontSize: "11px",
    },
  };

  var plotOptions = {
    pie: {
      center: [null, 80],
      dataLabels: {
        enabled: false,
      },

      showInLegend: true,
      point: {
        events: {
          legendItemClick: function(e) {
              return false;
          }
        }
      }
    },
  };
  var series = [
    {
      type: "pie",
      innerSize: "30%",
      borderRadius: 0,
      data: GraphData,
      states: {
        inactive: {
          enabled: false,
        },
      },
    },
  ];
  var accessibility = {
    enabled: true,
    screenReaderSection: {
      beforeChartFormat: '' // disables their auto "Interactive chart" label
    }
  };
  var json = {};
  json.chart = chart;
  json.credits = credits;
  json.title = title;
  json.tooltip = tooltip;
  json.legend = legend;
  json.series = series;
  json.plotOptions = plotOptions;
  json.accessibility = accessibility;
  const initGraph = () => {
    Highcharts.chart(`${id}`, json);
  };
  useEffect(() => {
    initGraph();
  }, [id,summaryReports]);
  return (
    <div
      id={id}
      style={{ height: "340px" }}
      title={title.text}
      aria-label={ariaLabel}
      className="AnalysisGraph"
    ></div>
  );
}
